export default "__VITE_ASSET__BUdtCbZZ__"